import {Injectable} from "@angular/core";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {
    altIfHeldCheckboxCellRenderer
} from "@irb/irb-editors/editor-security/renderers/altIfHeldCheckBoxCellRenderer.component";


@Injectable({
    providedIn: "root"
})
export class PortfolioEquivalentsGridLayoutService {

    constructor() {
    }


    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "altIfHeldCheckboxCellRenderer": altIfHeldCheckboxCellRenderer
        };
    }


    getColumnDefs(parent: any) {
        return [
            {
                headerName: "Delete All",
                headerComponent: "DeleteHeaderComponent",
                headerComponentParams: {
                    message: "Remove all equivalents?",
                    note: "iRebal will no longer consider these to be an equivalent or alternative to the defined securities.",
                    proceed: parent.deleteAll.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                cellRenderer: "DeleteCellComponent",
                cellRendererParams: {
                    message: "Remove equivalent?",
                    note: "iRebal will no longer consider this to be an equivalent or alternative to the defined security.",
                    proceed: parent.delete.bind(parent),
                    cancel: parent.cancelDelete.bind(parent)
                },
                resizable: false,
                minWidth: 25,
                maxWidth: 25,
                width: 25,
                suppressColumnsToolPanel: true
            },
            {
                headerName: 'Target Security',
                field: 'targetSecuritySymbol',
                minWidth: 100,
                width: 118,
                flex: 2,
                sort: "asc",
                suppressMovable: true
            },
            {
                headerName: 'Description',
                field: 'securityDescription',
                minWidth: 100,
                width: 150,
                flex: 2,
                cellRenderer: "cellRendererFormatter",
                suppressMovable: true
            },
            {
                headerName: 'Equivalent',
                field: 'eqSecuritySymbol',
                minWidth: 80,
                width: 135,
                flex: 2,
                sort: "asc",
                suppressMovable: true
            },
            {
                headerName: 'Equivalent Description',
                field: 'eqSecurityDescription',
                minWidth: 100,
                width: 120,
                flex: 2,
                cellRenderer: "cellRendererFormatter",
                suppressMovable: true
            },
            {
                headerName: 'Type',
                field: 'eqSecurityType',
                minWidth: 90,
                width: 90,
                flex: 1,
                valueGetter: this.formatSecurityType,
                suppressMovable: true
            },
            {
                headerName: "Alt if Held",
                field: "altIfHeldFlag",
                hide: false,
                cellStyle: {'text-align': 'center'},
                minWidth: 85,
                width: 85,
                flex: 1,
                cellRenderer: "altIfHeldCheckboxCellRenderer",
                suppressMovable: true,
                resizable: false
            }];
    }

    formatSecurityType(params: any) {
        switch (params.data.eqSecurityType) {
            case "EQUITY":
                return "Equity";
            case "EQ":
                return "Equity";
            case "MUTUAL_FUND":
                return "Mutual Fund";
            case "MF":
                return "Mutual Fund";
            case "CASH":
                return "Cash";
            case "GROUP":
                return "Group";
            case "BOND":
                return "Bond";
            case "OTHER":
                return "Other";
            case "EXTERNAL":
                return "External";
            case "CustCat":
                return "Category";
            case "OPTION":
                return "Option";
            default:
                return params.data.eqSecurityType;
        }
    }

}
